import { createAction, props } from '@ngrx/store';

import { FeatureFlagToggleList } from '../../interface/feature-flags.interface';

export const updated = createAction('[Feature Flags - Toggles] Updated', props<FeatureFlagToggleList>());
